"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FEATURES_URI = void 0;
exports.DEFAULT_FEATURES_URI = '/client/features';
//# sourceMappingURL=constants.js.map